import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Antes_Title } from '../../../../../utils/EN/Modals/SocialModals';

const ModalSocialAntes = () => {
  return (
    <>
      <ModalVideo
        id="antes-social"
        dataText={Antes_Title}
        videoSrc="https://player.vimeo.com/video/290403262?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_ANCES_DE_PARTIR"
      />
    </>
  );
};

export default ModalSocialAntes;
